import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';

export const useAuthRole = () => {
    const role = useSelector((s: RootState) => s.auth.role);
    if (!role) return null;
    return role.toLowerCase() as "admin" | "store" | "owner" | "organizer";
};

export const useAccessToken = () => {
    return useSelector((s: RootState) => s.auth.accessToken);
};

export const useAuthPermissions = () => {
    return useSelector((s: RootState) => s.auth.permissions);
};
